import React, { useState, useContext } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
// import { AuthServices } from "../../services/AuthService";
import { AuthContext } from "../../Context/AuthContext";
import { Link } from "react-router-dom";

export const Login = () => {
  const { login, user } = useContext(AuthContext);
  const [loader, setLoader] = useState(false);

  const client = async (model) => {
    setLoader(true);
    await login(model);
    setLoader(false);
  };
  const [passwordShow, setPasswordShow] = useState(false);
  const [showIcon, setShowIcon] = useState(false);
  const togglePasswordVisiblity = () => {
    setShowIcon(showIcon ? false : true);
    setPasswordShow(passwordShow ? false : true);
  };
  const load = <span className="fa fa-spin fa-spinner"></span>;
  return (
    <React.Fragment>
      <div className="login-reg-panel"></div>

      <div className="login-white-panel">
        <div className="login-show">
          <center>
            <div className="logo-img">
              <a href="/">
                <img
                  src="/img/Needle_logo.png"
                  width="191px"
                  alt="needlelogo"
                  height="42px"
                />
              </a>
              <br></br>
              <small></small>
            </div>
          </center>
          <Formik
            initialValues={{ email: "", password: "" }}
            validate={(values) => {
              const errors = {};
              if (!values.email) {
                errors.email = "Required";
              } else if (
                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
              ) {
                errors.email = "Invalid email address";
              }
              return errors;
            }}
            onSubmit={(values) => {
              // setTimeout(() => {
              client(values);
              //     alert(JSON.stringify(values, null, 2));
              //     setSubmitting(false);
              // }, 400);
            }}
          >
            {({ isSubmitting }) => (
              <Form>
                <div className="form-group">
                  <Field
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Email"
                  />

                  <ErrorMessage name="email" component="div" />
                </div>

                <div className="form-group">
                  <Field
                    type={passwordShow ? "text" : "password"}
                    name="password"
                    className="form-control"
                    placeholder="Password"
                  />
                  <span
                    className="float-right password-icon"
                    onClick={togglePasswordVisiblity}
                  >
                    <i
                      className={showIcon ? "fa fa-eye-slash" : "fa fa-eye"}
                    ></i>
                  </span>

                  <ErrorMessage name="password" component="div" />
                </div>

                <div className="float-right">
                  <Link to="/reset-password" className="text-dark">
                    Can't remember password?
                  </Link>
                </div>
                <span className="clearfix"></span>

                <div className="text-center mt-5">
                  <button
                    type="submit"
                    // disabled={isSubmitting}
                    className="btn-large btn"
                  >
                    {loader ? load : "Login"}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>

      <div className="login-reg-panel-image"></div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/auth/login.js